import 'fit-text-webcomponent';
import '../../../src/docReady.js';
import Dom from '../../../src/Dom.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import './style.scss';

const moduleSelector = '.eiovisual-titolo1';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo titolo1');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {
    
    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        // Tasks on images
        setTimeout(() => { this.task1(); },0); // prima l'immagine centrale
    }
    
    /**
     * FIT-TEXT
     * @returns {undefined}
     */
    task1() {
        // seleziona gli elementi fit-text
        let $target = this.$module.querySelectorAll('.fit-text');
        
        // applica fit-text
        $target.forEach(($el,index) => {
            Dom.wrapInner($el,'fit-text');
        });
    }
    
}

// export
export default new Module();